import { motion } from 'framer-motion';
import { ReactNode } from 'react';
import { useReducedMotion } from '../../hooks/useReducedMotion';
import { pageVariants } from '../../utils/motion';

interface PageTransitionProps {
  children: ReactNode;
  enableSharedElements?: boolean;
}

export function PageTransition({ 
  children, 
  enableSharedElements = true 
}: PageTransitionProps) {
  const prefersReducedMotion = useReducedMotion();
  
  // Get the appropriate variants based on motion preference
  const variants = pageVariants(prefersReducedMotion);
  
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={variants}
      transition={{ 
        duration: prefersReducedMotion ? 0.2 : 0.3, 
        ease: 'easeInOut',
        // Disable exit animation when we have shared elements
        ...(enableSharedElements ? { exit: { duration: 0 } } : {})
      }}
    >
      {children}
    </motion.div>
  );
} 